import { AFrameScene } from '../lib/aframe-components'
import './main.css'

declare let React: any

// URL del modello 3D hardcoded
const MODEL_URL = 'https://iscag-ei.it/wp-content/materiale/animazioni-3d/cubo-malberti.glb'

// Scena A-Frame hardcoded — identica al template "generic" di model-config.js
// Route pubblica: /moving — nessun token richiesto
const SCENE_HTML = `
<a-scene
  custom-qr-loading="splashImage: https://iscag-ei.it/wp-content/materiale/splashscreenarweb.png; showBackButton: false"
  xrextras-gesture-detector
  xrextras-loading
  renderer="colorManagement: true; physicallyCorrectLights: true;"
  gltf-model="dracoDecoderPath: https://www.gstatic.com/draco/versioned/decoders/1.5.7/"
  xrweb="disableWorldTracking: true">

  <a-assets>
    <a-asset-item id="genericModel" src="${MODEL_URL}"></a-asset-item>
  </a-assets>

  <a-camera
    id="camera"
    position="0 5 5"
    raycaster="objects: .cantap"
    cursor="fuse: false; rayOrigin: mouse;">
  </a-camera>

  <a-light type="ambient" intensity="0.6"></a-light>

  <a-entity
    light="type: directional;
       intensity: 0.8;
       castShadow: true;
       shadowMapHeight: 2048;
       shadowMapWidth: 2048;
       shadowCameraTop: 10;
       target: #model;"
    position="1 4.3 2.5"
    xrextras-attach="target: model; offset: 1 15 3;"
    shadow>
  </a-entity>

  <a-entity
    id="model"
    gltf-model="#genericModel"
    class="cantap"
    scale="3 3 3"
    position="0 -5 -5"
    rotation="0 0 0"
    animation-mixer="clip: Scene; loop: repeat; crossFadeDuration: 0.4"
    xrextras-hold-drag
    xrextras-two-finger-rotate
    xrextras-pinch-scale
    shadow>
  </a-entity>

  <a-plane id="ground" position="0 0 0" rotation="-90 0 0" width="20" height="20" material="shader: shadow" shadow></a-plane>
</a-scene>
`

const MovingExperience = () => {
    return (
        <AFrameScene sceneHtml={SCENE_HTML} />
    )
}

export { MovingExperience }
